module.exports = __webpack_public_path__ + "img/residential bungalow - Gadhinglaj copy.833746a4.jpg";